import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-utils';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay, takeUntil } from 'rxjs/operators';
import { IDP_APP } from '../constants/login-constant';
import {
  PersonalizationEngineRequest,
  PersonalizationEngineResponse
} from '../models/aem/personalization-engine.interface';
import { LoginModalEndpointsKeys } from '../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class FlowRouterService {
  errorHandler = handleError.bind(this);

  setupMfaFlowRouter$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getSetupMfaFlag(authenticationConfig: OauthAEMConfig): void {
    if (authenticationConfig?.MFA_FLOW) {
      this.getPersonalizationEngine(this.getRequestParamForMfaPE())
        .pipe(shareReplay(1), takeUntil(this.unsubscribe$))
        .subscribe((response: PersonalizationEngineResponse) => {
          if (
            response &&
            response['flowrouter:setup-mfa']?.parsys?.router?.endpoint ===
              'setup-mfa-yes'
          ) {
            this.setupMfaFlowRouter$.next(true);
          } else {
            this.setupMfaFlowRouter$.next(false);
          }
        });
    } else {
      return;
    }
  }

  getRequestParamForMfaPE(): PersonalizationEngineRequest {
    return {
      userdata: [],
      requestparam: {
        campaignId: ['flowrouter:setup-mfa'],
        format: 'json'
      }
    };
  }

  getPersonalizationEngine = (
    request: PersonalizationEngineRequest
  ): Observable<PersonalizationEngineResponse> =>
    new ApiBuilder<PersonalizationEngineRequest, PersonalizationEngineResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['PERSONALIZATION_ENGINE_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .timeOut(3000)
      .errorHandler(this.errorHandler)
      .create();
}
